(function () {
  'use strict';

  angular.module('wsLrs.directives').directive("wsOpenNewWindow", function () {
    return function (scope, element, attrs) {
      var newWindow = scope.$eval(attrs.wsOpenNewWindow);
      element.attr("target", newWindow === true ? "_blank" : "_self");
    };
  });
})();
